import React from 'react';
import { getPricingCatalog, isPricingConfigFromS3 } from '../lib/pricingCatalogStore';

/** Shown when dev ECS loads pricing.yaml from S3 instead of the image embed. */
export default function PricingConfigS3Banner({ catalog: catalogProp = null }) {
  const catalog = catalogProp ?? getPricingCatalog();
  if (!catalog || !isPricingConfigFromS3(catalog)) return null;

  const version = catalog?.config_version || 'unknown';
  const source = catalog?.config_source || '';

  return (
    <div
      role="status"
      data-testid="pricing-config-s3-banner"
      style={bannerStyle}
    >
      <strong style={{ fontWeight: 600 }}>Dev pricing override active</strong>
      {' — '}
      Valuations use <code style={codeStyle}>pricing.yaml</code> from S3, not the config baked into this deployment.
      {version ? (
        <>
          {' '}
          Config version <code style={codeStyle}>{version}</code>.
        </>
      ) : null}
      {source ? (
        <span style={sourceStyle} title={source}>
          {' '}
          ({source.replace(/^s3:\/\//, '')})
        </span>
      ) : null}
    </div>
  );
}

const bannerStyle = {
  background: '#fff7e6',
  borderBottom: '1px solid #ffd591',
  color: '#874d00',
  fontSize: '13px',
  lineHeight: 1.5,
  padding: '10px 32px',
  fontFamily: 'var(--font)',
};

const codeStyle = {
  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
  fontSize: '12px',
  background: 'rgba(0,0,0,0.06)',
  padding: '1px 5px',
  borderRadius: '4px',
};

const sourceStyle = {
  opacity: 0.85,
  fontSize: '12px',
};
